import React from "react";

const FPUHistoryContent = () => {
  const historicalStats = {
    totalPeacekeepers: 3536,
    ipoPersonnel: 1022,
    fpuPersonnel: 2520,
    startYear: 1989,
  };

  const majorMissions = [
    {
      mission: "UNTAG",
      location: "Namibia",
      year: "1989",
      personnel: 34,
      type: "IPO",
    },
    {
      mission: "UNTAC",
      location: "Kamboja",
      year: "1992-1993",
      personnel: 307,
      type: "IPO",
    },
    {
      mission: "UNIMBH",
      location: "Bosnia",
      year: "1995-2001",
      personnel: 136,
      type: "IPO + FPU",
    },
    {
      mission: "UNMISS",
      location: "Sudan Selatan",
      year: "2007-2010",
      personnel: 36,
      type: "IPO",
    },
    {
      mission: "MINUSCA",
      location: "Afrika Tengah",
      year: "2014-Sekarang",
      personnel: 140,
      type: "FPU",
    },
  ];

  return (
    <div className="p-8">
      <div className="space-y-8">
        {/* Historical Overview */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">
            Kontribusi Polri dalam Misi Pemeliharaan Perdamaian PBB
          </h2>
          <p className="leading-relaxed text-base-content/70 mb-6">
            Sejak awal kontribusi Polri dalam Misi Pemeliharaan Perdamaian PBB
            tahun 1989, jumlah peacekeepers Polri mencapai{" "}
            <span className="font-bold text-primary">
              {historicalStats.totalPeacekeepers} personel
            </span>
            .
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-primary/10 rounded-lg p-4 text-center border-2 border-primary/20">
              <div className="text-3xl mb-3">👮‍♂️</div>
              <h3 className="font-semibold text-lg mb-2">
                Individual Police Officer
              </h3>
              <p className="text-primary font-bold text-2xl">
                {historicalStats.ipoPersonnel.toLocaleString()}
              </p>
              <p className="text-sm text-base-content/70 mt-1">Personel IPO</p>
            </div>

            <div className="bg-secondary/10 rounded-lg p-4 text-center border-2 border-secondary/20">
              <div className="text-3xl mb-3">👥</div>
              <h3 className="font-semibold text-lg mb-2">Formed Police Unit</h3>
              <p className="text-secondary font-bold text-2xl">
                {historicalStats.fpuPersonnel.toLocaleString()}
              </p>
              <p className="text-sm text-base-content/70 mt-1">Personel FPU</p>
            </div>

            <div className="bg-accent/10 rounded-lg p-4 text-center border-2 border-accent/20">
              <div className="text-3xl mb-3">📅</div>
              <h3 className="font-semibold text-lg mb-2">Pengalaman</h3>
              <p className="text-accent font-bold text-2xl">
                {new Date().getFullYear() - historicalStats.startYear}+
              </p>
              <p className="text-sm text-base-content/70 mt-1">
                Tahun Kontribusi
              </p>
            </div>
          </div>
        </div>

        {/* Timeline Evolution */}
        <div className="bg-base-200 rounded-xl p-6">
          <div className="flex flex-col lg:flex-row gap-6">
            {/* Content Section */}
            <div className="lg:w-2/3">
              <h2 className="text-2xl font-bold mb-6">
                Evolusi Kontribusi Polri
              </h2>
              <div className="relative">
                <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-base-300"></div>
                <div className="space-y-6">
                  <div className="flex items-start gap-6">
                    <div className="bg-primary rounded-full w-16 h-16 flex items-center justify-center flex-shrink-0 relative z-10">
                      <span className="text-white font-bold">1989</span>
                    </div>
                    <div className="bg-base-100 rounded-lg p-4 flex-1">
                      <h3 className="font-semibold text-lg mb-2">
                        Era Awal - UNTAG Namibia
                      </h3>
                      <p className="text-base-content/70">
                        Debut Polri dalam misi pemeliharaan perdamaian PBB
                        dengan mengirimkan 34 personel sebagai Individual Police
                        Officer (IPO) ke Namibia.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-6">
                    <div className="bg-secondary rounded-full w-16 h-16 flex items-center justify-center flex-shrink-0 relative z-10">
                      <span className="text-white font-bold">1992</span>
                    </div>
                    <div className="bg-base-100 rounded-lg p-4 flex-1">
                      <h3 className="font-semibold text-lg mb-2">
                        Ekspansi Besar - UNTAC Kamboja
                      </h3>
                      <p className="text-base-content/70">
                        Kontribusi terbesar dengan 307 personel IPO, menandai
                        komitmen serius Indonesia dalam pemeliharaan perdamaian
                        dunia.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-6">
                    <div className="bg-accent rounded-full w-16 h-16 flex items-center justify-center flex-shrink-0 relative z-10">
                      <span className="text-white font-bold">2000s</span>
                    </div>
                    <div className="bg-base-100 rounded-lg p-4 flex-1">
                      <h3 className="font-semibold text-lg mb-2">
                        Era Diversifikasi Misi
                      </h3>
                      <p className="text-base-content/70">
                        Polri mulai terlibat dalam berbagai jenis misi di
                        Bosnia, Sudan, dan wilayah konflik lainnya dengan peran
                        yang semakin strategis.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-6">
                    <div className="bg-primary rounded-full w-16 h-16 flex items-center justify-center flex-shrink-0 relative z-10">
                      <span className="text-white font-bold">2014</span>
                    </div>
                    <div className="bg-base-100 rounded-lg p-4 flex-1">
                      <h3 className="font-semibold text-lg mb-2">
                        Era FPU Modern - MINUSCA
                      </h3>
                      <p className="text-base-content/70">
                        Dimulainya pengiriman Formed Police Unit (FPU) ke Afrika
                        Tengah dengan 140 personel, menandai era baru kontribusi
                        Polri dalam format unit terorganisir.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Images Section */}
            <div className="lg:w-1/3">
              <div className="bg-base-100 rounded-lg p-4">
                <h4 className="font-semibold mb-3 text-center">
                  Dokumentasi FPU
                </h4>
                <div className="grid gap-3">
                  {/* FPU images 0-4 */}
                  {[0, 1, 2, 3, 4].map((imgNumber) => (
                    <div
                      key={imgNumber}
                      className="bg-base-200 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow"
                    >
                      <img
                        src={`/gallery/fpu/FPU_${imgNumber}.jpg`}
                        alt={`FPU dokumentasi ${imgNumber}`}
                        loading="lazy"
                        className="w-full h-32 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.src = "/placeholder-image.jpg";
                          target.alt = "Gambar tidak tersedia";
                        }}
                        onClick={() =>
                          window.open(
                            `/gallery/fpu/FPU_${imgNumber}.jpg`,
                            "_blank",
                          )
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Major Missions Table */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Misi-Misi Utama Polri</h2>
          <div className="overflow-x-auto">
            <table className="table w-full">
              <thead>
                <tr className="bg-base-300">
                  <th>Misi</th>
                  <th>Lokasi</th>
                  <th>Periode</th>
                  <th>Personel</th>
                  <th>Tipe</th>
                </tr>
              </thead>
              <tbody>
                {majorMissions.map((mission, index) => (
                  <tr key={index} className="hover:bg-base-100">
                    <td className="font-semibold">{mission.mission}</td>
                    <td>{mission.location}</td>
                    <td>{mission.year}</td>
                    <td className="text-center">
                      <span className="badge badge-primary">
                        {mission.personnel}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`badge ${
                          mission.type.includes("FPU")
                            ? "badge-secondary"
                            : mission.type.includes("IPO")
                              ? "badge-accent"
                              : "badge-ghost"
                        }`}
                      >
                        {mission.type}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Achievements & Recognition */}
        <div className="bg-gradient-to-r from-primary/20 to-secondary/20 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Pencapaian dan Pengakuan</h2>
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-base-100 rounded-lg p-6">
                <h3 className="font-semibold text-lg mb-4 flex items-center gap-2">
                  <span className="text-2xl">🏆</span>
                  Prestasi Internasional
                </h3>
                <ul className="space-y-2 text-base-content/70">
                  <li className="flex items-start gap-2">
                    <span className="text-primary">•</span>
                    <span>Pengakuan PBB atas profesionalisme Polri</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary">•</span>
                    <span>Kontributor peacekeeping terpercaya</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary">•</span>
                    <span>Model pelatihan untuk negara lain</span>
                  </li>
                </ul>
              </div>

              <div className="bg-base-100 rounded-lg p-6">
                <h3 className="font-semibold text-lg mb-4 flex items-center gap-2">
                  <span className="text-2xl">🌍</span>
                  Dampak Global
                </h3>
                <ul className="space-y-2 text-base-content/70">
                  <li className="flex items-start gap-2">
                    <span className="text-secondary">•</span>
                    <span>Stabilisasi keamanan di wilayah konflik</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-secondary">•</span>
                    <span>Pembangunan kapasitas kepolisian lokal</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-secondary">•</span>
                    <span>Perlindungan masyarakat sipil</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Diversification Charts */}
            <div className="bg-base-100 rounded-lg p-6">
              <h3 className="font-semibold text-lg mb-4 flex items-center gap-2">
                <span className="text-2xl">📊</span>
                Diversifikasi Misi dan Kontribusi Terkini
              </h3>
              <p className="text-base-content/70 mb-4">
                Diversifikasi misi dimana Polri memberikan kontribusinya
                mengalami peningkatan yang signifikan, menunjukkan komitmen
                Indonesia dalam perdamaian dunia melalui strategi dan performa
                optimal para peacekeeper Polri di berbagai daerah penugasan.
              </p>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div className="bg-base-200 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow">
                  <img
                    src="/gallery/fpu/FPU_5.jpg"
                    alt="Diversifikasi Misi Polri"
                    loading="lazy"
                    className="w-full h-64 object-contain hover:scale-105 transition-transform duration-300 cursor-pointer"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = "/placeholder-image.jpg";
                      target.alt = "Gambar tidak tersedia";
                    }}
                    onClick={() =>
                      window.open("/gallery/fpu/FPU_5.jpg", "_blank")
                    }
                  />
                </div>
                <div className="bg-base-200 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow">
                  <img
                    src="/gallery/fpu/FPU_6.jpg"
                    alt="Peacekeeper Polri On The Ground"
                    loading="lazy"
                    className="w-full h-64 object-contain hover:scale-105 transition-transform duration-300 cursor-pointer"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = "/placeholder-image.jpg";
                      target.alt = "Gambar tidak tersedia";
                    }}
                    onClick={() =>
                      window.open("/gallery/fpu/FPU_6.jpg", "_blank")
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Future Vision */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Visi Masa Depan</h2>
          <div className="bg-base-100 rounded-lg p-6">
            <p className="leading-relaxed text-base-content/70 mb-4">
              Polri berkomitmen untuk terus meningkatkan kontribusi dalam misi
              pemeliharaan perdamaian PBB dengan meningkatkan kualitas personel,
              modernisasi peralatan, dan memperluas cakupan kemampuan
              operasional untuk mendukung perdamaian dunia.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="text-center">
                <div className="text-2xl mb-2">📈</div>
                <h4 className="font-semibold">Peningkatan Kualitas</h4>
                <p className="text-sm text-base-content/70">
                  Pelatihan dan standar internasional
                </p>
              </div>
              <div className="text-center">
                <div className="text-2xl mb-2">🔧</div>
                <h4 className="font-semibold">Modernisasi</h4>
                <p className="text-sm text-base-content/70">
                  Peralatan dan teknologi terkini
                </p>
              </div>
              <div className="text-center">
                <div className="text-2xl mb-2">🤝</div>
                <h4 className="font-semibold">Kerjasama</h4>
                <p className="text-sm text-base-content/70">
                  Koordinasi internasional yang lebih baik
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FPUHistoryContent;
